import script from "./FullscreenSpin.vue?vue&type=script&lang=ts&setup=true"
export * from "./FullscreenSpin.vue?vue&type=script&lang=ts&setup=true"

import "./FullscreenSpin.vue?vue&type=style&index=0&id=a5c6b41c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5c6b41c"]])

export default __exports__